import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";

export default function Terms() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 bg-white">
        <div className="w-full px-6 md:px-10 lg:px-14 pt-28 md:pt-36 pb-20 md:pb-28">
          <div className="max-w-3xl mx-auto">
            <span className="inline-block text-sm font-medium text-[#4CAF50] border border-[#4CAF50]/30 rounded-full px-4 py-1.5 mb-5">
              Legal
            </span>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 tracking-tight mb-8">
              Terms & Conditions
            </h1>
            <p className="text-sm text-gray-500 mb-10">
              Last updated: May 3, 2025
            </p>

            <div className="space-y-10 text-gray-700 text-sm md:text-base leading-relaxed">
              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">
                  1. Agreement to Terms
                </h2>
                <p>
                  By downloading, installing, or using the ScanDoc mobile
                  application ("the App"), you agree to be bound by these Terms
                  and Conditions ("Terms"). If you do not agree to these Terms,
                  you must not use the App.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">
                  2. License to Use
                </h2>
                <p>
                  ForceKeys grants you a limited, non-exclusive,
                  non-transferable, revocable license to use the App for your
                  personal or business use, subject to these Terms. You may not
                  copy, modify, distribute, sell, or lease any part of the App
                  without our prior written consent.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">
                  3. User Responsibilities
                </h2>
                <p className="mb-3">
                  You are responsible for your use of the App and for any
                  content you create, scan, or import. You agree not to:
                </p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Use the App for any illegal or unauthorized purpose.</li>
                  <li>
                    Attempt to interfere with the proper working of the App or
                    bypass any measures we may use to restrict access.
                  </li>
                  <li>
                    Upload or distribute any content that infringes on
                    third-party intellectual property rights.
                  </li>
                  <li>
                    Reverse engineer, decompile, or disassemble the App.
                  </li>
                </ul>
              </section>

              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">
                  4. Intellectual Property
                </h2>
                <p>
                  The App and all related materials, including but not limited to
                  software, graphics, logos, and designs, are the intellectual
                  property of ForceKeys and are protected by applicable
                  copyright and trademark laws. You may not use our trademarks
                  without prior written permission.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">
                  5. Disclaimer of Warranties
                </h2>
                <p>
                  The App is provided on an "as is" and "as available" basis.
                  ForceKeys makes no warranties, expressed or implied, regarding
                  the App's reliability, accuracy, or fitness for a particular
                  purpose. We do not guarantee that the App will be
                  uninterrupted or error-free.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">
                  6. Limitation of Liability
                </h2>
                <p>
                  To the maximum extent permitted by law, ForceKeys shall not be
                  liable for any indirect, incidental, special, consequential,
                  or punitive damages arising out of or relating to your use of
                  the App, even if we have been advised of the possibility of
                  such damages.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">
                  7. Termination
                </h2>
                <p>
                  We may terminate or suspend your access to the App at any
                  time, without prior notice or liability, for any reason,
                  including if you breach these Terms. Upon termination, your
                  right to use the App will immediately cease.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">
                  8. Governing Law
                </h2>
                <p>
                  These Terms shall be governed by and construed in accordance
                  with the laws of the jurisdiction in which ForceKeys operates,
                  without regard to its conflict of law provisions.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">
                  9. Changes to Terms
                </h2>
                <p>
                  We reserve the right to modify these Terms at any time. If we
                  make material changes, we will notify you by updating the
                  "Last updated" date and posting the new Terms. Your continued
                  use of the App after any changes indicates your acceptance of
                  the revised Terms.
                </p>
              </section>

              <section>
                <h2 className="text-lg font-semibold text-gray-900 mb-3">
                  10. Contact Us
                </h2>
                <p>
                  If you have any questions about these Terms, please contact us
                  at{" "}
                  <a
                    href="mailto:scandoc@forcekeys.com"
                    className="text-[#4A90D9] hover:underline"
                  >
                    scandoc@forcekeys.com
                  </a>
                  .
                </p>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}